import OutsideFooter from "./OutsideFooter";
export default OutsideFooter;
